export default "__VITE_ASSET__edOgLVum__"